// Parse a millisecond duration from context. Accepts finite non-negative
// numbers and their string form (scalar context values are stringified).
export function toDurationMs(input) {
  if (typeof input === 'number') {
    if (!Number.isFinite(input) || input < 0) return undefined;
    return input;
  }
  if (typeof input !== 'string' || !/^\d+$/.test(input)) return undefined;
  return toDurationMs(Number(input));
}
export function millisecondsToDurationRecord(ms) {
  let remaining = ms;
  const hours = Math.floor(remaining / 3600000);
  remaining %= 3600000;
  const minutes = Math.floor(remaining / 60000);
  remaining %= 60000;
  const seconds = Math.floor(remaining / 1000);
  remaining %= 1000;
  const record = {};
  if (hours > 0) record.hours = hours;
  if (minutes > 0) record.minutes = minutes;
  if (seconds > 0) record.seconds = seconds;
  if (remaining > 0) record.milliseconds = remaining;
  if (Object.keys(record).length === 0) record.seconds = 0;
  return record;
}
function getDurationFormatConstructor() {
  return Intl.DurationFormat;
}
function unitDisplayForStyle(style) {
  if (style === 'long') return 'long';
  if (style === 'narrow') return 'narrow';
  return 'short';
}
function formatDurationWithNumberFormat(record, locale, style) {
  const unitDisplay = unitDisplayForStyle(style);
  const parts = [];
  if (record.hours !== undefined) {
    parts.push(new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'hour',
      unitDisplay
    }).format(record.hours));
  }
  if (record.minutes !== undefined) {
    parts.push(new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'minute',
      unitDisplay
    }).format(record.minutes));
  }
  if (record.seconds !== undefined) {
    parts.push(new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'second',
      unitDisplay
    }).format(record.seconds));
  }
  if (record.milliseconds !== undefined) {
    parts.push(new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'millisecond',
      unitDisplay
    }).format(record.milliseconds));
  }
  return parts.join(' ');
}
export function formatDurationMs(ms, locale, style) {
  const record = millisecondsToDurationRecord(ms);
  const DurationFormat = getDurationFormatConstructor();
  if (DurationFormat) {
    const formatted = new DurationFormat(locale, {
      style
    }).format(record);
    if (formatted !== '') return formatted;
  }
  return formatDurationWithNumberFormat(record, locale, style);
}